import { api } from "./api";

export const customerList = async () => {
  const { data } = await api.get("/products/customer/list");

  return data;
};

export const customerCreate = async (body: any) => {
  const { data } = await api.post("/products/customer/create", body);

  return data;
};
